import Image from 'next/image'
import Input from '../General/Input'
import styled from 'styled-components'
import Select from '../General/Select'
import Button from '../General/Button'
import EnquiryForm from '../Layout/EnquiryForm'
import { useDispatch, useSelector } from 'react-redux'
import { getAPIList, getCountryList, submitEnquiry, getCertificateList, openEnquiryModal, getPharmacopoeiaGrades, deleteFile } from '../../store/CoreSlice'
import { useState, useEffect, useRef } from 'react';
import enquiryFormSchema from '../../validations/Enquiry';
import { useFormik } from 'formik';
import EnquirySuccess from '../Layout/EnquirySuccess';
import format from "date-fns/format";
import FileInput from '../General/FileInput';
import { setFileData } from '../../store/CoreSlice';
import TextArea from '../General/TextArea';
import helpers from '../../utils/helpers'
import DatePicker from '../General/DatePicker'

const StyledQuantitySuffix = styled.div`
	border-radius : 4px;
	width : 35px;
	height : 35px;
	background : transparent;
	color : #384C9A;
`



function Enquiry({ firstHeading, secondHeading, subText } : any) {
	let initialValues: { [k: string]: any } = {

		// Autocomplete fields
		product_string : '',
		country_string : '',

		// Main fields
		product : null,
		product_text : '',
		quantity: null,
		price: null,
		expected_date: null,
		unit: 1,
		message: '',
		required_manufacturer : '',
		shipping_terms : '',

		// selected fields
		expected_certificates : [],
		pharmacopoeia_grades : [],
	}
	const [showProductResults, setShowProductResults] = useState(false);
	const [showCountryResults, setShowCountryResults] = useState(false);
	const [productString, setProductString] = useState('');
	const [countryString, setCountryString] = useState('');
	const [casNumber, setCasNumber] = useState('');
	const [showEnquiryModal, setShowEnquiryModal] = useState(false);

	const dispatch : any = useDispatch();
	const { 
		values, 
		errors,  
		touched, 
		handleBlur, 
		handleChange, 
		handleSubmit, 
		resetForm,
		setFieldValue
	} = useFormik({
		initialValues : initialValues,
		validationSchema : enquiryFormSchema,

		onSubmit : (values : any) => {
			
			const payload = {...values};
			payload['attachment'] = files.length ? files[0].id : null;

			// In case a Product String is there but not selected any predefined product.
			if(payload.product_string !== '' && payload.product === null) {
				payload.product_text = payload.product_string;
				setFieldValue('product_text', payload.product_string)
			}

			if(user.isLoggedIn) {
				dispatch(submitEnquiry(payload));
			}
			else {
				dispatch(openEnquiryModal(payload));
				setShowEnquiryModal(true);
			}
		} 
	});
	const {
		apiList, 
		countryList,
		certificateList,
		pharmacopoeiaGradesList,
		enquiryState,
		files
	} = useSelector((state : any) => state.core);
	const { user } = useSelector((state : any) => state.auth);

	useEffect(() => {
		dispatch(getCertificateList());
		dispatch(getPharmacopoeiaGrades());
	}, []);

	useEffect(() => {
		if (enquiryState.showSuccessModal) {
			resetEnquiryForm();
		}
	}, [enquiryState.showSuccessModal])

	// FUNCTIONS
	const handleProductSearch = (event : any) => {
		setProductString(() => event.target.value);
		setFieldValue('product_string', event.target.value);
		setShowProductResults(true);
		const params = {
			page: 1,
			page_size: 5,
			search: event.target.value
		}
		dispatch(getAPIList(params));

		if(event.target.value == '') 
			setFieldValue('product', null);
	} 

	const selectProduct = (data : any) => {
		setProductString(() => data.name);
		setCasNumber(() => data.cas_number);
		setFieldValue('product_string', data.name);
		setFieldValue('product', data.id);
		setShowProductResults(false);
	}

	const handleProductClear = () => {
		setProductString(() => '');
		setFieldValue('product_string', '');
		setFieldValue('product', null);
		setCasNumber(() => '')
	}

	const handleCountrySearch = (event : any) => {
		setCountryString(() => event.target.value);
		setFieldValue('country_string', event.target.value);
		setShowCountryResults(() => true);
		const params = {
			search: event.target.value
		}
		dispatch(getCountryList(params));

		if(event.target.value == '') 
			setFieldValue('country', null);
	}

	const selectCountry = (data : any) => {
		setCountryString(() => data.name);
		setFieldValue('country_string', data.name);
		setFieldValue('country',data.id);
		setShowCountryResults(() => false);
	}

	const handleCountryClear = () => {
		setCountryString(() => '');
		values.country_string = '';
		setFieldValue('country_string', '');
		setFieldValue('country', null);
	}

	const resetEnquiryForm = () => {
		resetForm();
		setProductString('');
		setCountryString('');
		dispatch(setFileData({
			data : [],
			action : 'replace'
		}));
	}	

	return (
		<>
			<div id='enquiry-section' className='pb-10 min-h-[300px] relative lg:flex justify-between items-center --align overflow-x-hidden py-[40px] lg:py-[70px]'>
				<img className='hidden md:inline-block absolute top-[80px] -left-[60px] z-0' src={'/Home/Ellipse.svg'} width={300} height={100} alt="" />
				<img className='hidden md:inline-block absolute bottom-[100px] -right-[100px] -z-9' src={'/Home/Ellipse.svg'} width={300} height={100} alt="" />


				<div className={`text-theme-dark-saffron text-left mb-8 lg:w-[40%] relative`} >
					<h1 className='text-3xl font-semibold -mb-4 lg:-mb-0 md:text-2xl lg:text-[2.9rem]'> {firstHeading} </h1>
					<h1 className='text-3xl font-semibold pt-5 md:text-2xl lg:text-[2.9rem] mb-3'> {secondHeading} </h1>
					<h2 className='text-sm lg:text-xl text-theme-blue'> {subText} </h2>
					<div className='text-sm lg:text-lg mt-8'>
					<div className='flex mb-[6px]'>
							<img src="/Home/Call.svg" alt="" className='w-[29px] h-[29px] mr-[9px]' />
							<p className='text-theme-dark-saffron'>+91-8655735634</p> 
						</div>

						<div className='flex'>
							<img src="/Home/Email.svg" alt="" className='w-[29px] h-[29px] mr-[9px]' />
							<p className='text-theme-dark-saffron'>support@apidrug.com</p> 
						</div>

					</div>
				</div>

				<form 
					id='enquiry-form'
					onSubmit={handleSubmit} 
					className={`
                                relative 
                                z-1 
                                bg-[#FEF7F5] 
                                grid 
                                grid-cols-1 
								rounded-[5px]
                                gap-4 
                                md:grid-cols-2 
                                lg:grid-cols-4
                                gap-y-4
								p-5
                                lg:p-[30px]
                                lg:w-[70%]
                            `}
				>				
					<div className='lg:col-span-2 relative'>
						<Input
							label='Product'
                            labelColor = '#305399'
							placeholder='eg. Paracetamol'
							search
							name = 'product_string'
							onInput={handleProductSearch}
							value={productString}
							background='#FEF7F5'
							color='#314783'
							outerProperties={`rounded ${!productString && 'py-[11.5px]'} border border-[#0000001a]`}
							error={errors.product_string}
							touched={touched.product_string}
							onBlur = {(e : any) => {
								setTimeout(() => {
									setShowProductResults(() => false);
									handleBlur(e)
								}, 300);
							}}
							searchResults={
								showProductResults &&
								apiList.list.map((data: any, index: number) => (
									<div className="
											flex 
											justify-between 
											text-[12px] 
											my-1 
											py-2 
											text-theme-black 
											font-light 
											cursor-pointer 
											rounded 
											items-center 
											hover:bg-[#D4D9E7]/50 
											font-semibold"
										onClick={() => selectProduct(data)}
										key={index}
									>
										<p className="flex flex-col font-light">
											<span>
												{data.name} ({data.cas_number})
											</span>
											<small> {data.product_type} </small>
										</p>
									</div>
								))
							}
							suffix={
								productString &&
								<div onClick={handleProductClear} className='cursor-pointer text-theme-blue p-2 m-1 text-sm flex justify-center items-center'>
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
										<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
									</svg>
								</div>
							}
						/>
						{
							casNumber ?
							<small className='text-[#9ca3af] inline-block mt-2 opacity-70'> CAS # { casNumber } </small>
							:
							<small className='text-[#9ca3af] inline-block mt-2 opacity-70'> CAS # will be auto populated </small> 
						}
					</div>

					<div className='w-full ml-auto'>
						<Input
							className='mb-3'
							label='Quantity'
                            labelColor = '#305399'
							placeholder='eg. 10'
                            background='#FEF7F5'
							color='#314783'
							outerProperties='rounded py-0.5 border border-[#0000001a]'
							suffix={
								<StyledQuantitySuffix className='text-white bg-theme-blue m-1 text-sm flex justify-center items-center'>
									KG
								</StyledQuantitySuffix>
							}
							onChange={handleChange}
							name='quantity'
							value={values.quantity}
							onBlur={handleBlur}
							error={errors.quantity}
							touched={touched.quantity}
						/>
					</div>

					<Input
						className='mb-3'
						label='Target Price'
                        labelColor = '#305399'
						placeholder='eg. 220'
                        background='#FEF7F5'
						color='#314783'
						outerProperties='rounded py-0.5 border border-[#0000001a]'
						suffix={
							<StyledQuantitySuffix className='text-white bg-theme-blue p-2 m-1 text-sm flex justify-center items-center'>
								$
							</StyledQuantitySuffix>
						}
						onChange={handleChange}
						name='price'
						value={values.price}
						onBlur={handleBlur}
						error={errors.price}
						touched={touched.price}
					/>

					<div className='relative'>
						<Input
							label='Target Market'
                            labelColor = '#305399'
							placeholder='eg. USA'
							search
							name = 'country_string'
							onInput={handleCountrySearch}
							value={countryString}
                            background='#FEF7F5'
							color='#314783'
							outerProperties={`rounded ${!countryString && 'py-[11.5px]'} border border-[#0000001a]`}
							error={errors.country_string}
							touched={touched.country_string}
							onBlur = {(e : any) => {
								setTimeout(() => {
									setShowCountryResults(() => false);
									handleBlur(e)
								}, 300);
							}}
							searchResults={
								showCountryResults &&
								countryList.list.map((data: any, index: number) => (
									<div className="
												flex 
												justify-between 
												text-[12px] 
												my-1 
												py-2 
												text-theme-black 
												font-light 
												cursor-pointer 
												rounded 
												items-center 
												hover:bg-[#D4D9E7]/50 
												font-semibold"
										onClick={() => selectCountry(data)}
										key={index}
									>
										<p className="flex flex-col font-light">
											<span>
												{data.name}
											</span>
										</p>
									</div>
								))
							}
							suffix={
								countryString &&
								<div onClick={handleCountryClear} className='cursor-pointer text-theme-blue p-2 m-1 text-sm flex justify-center items-center'>
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
										<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
									</svg>
								</div>
							}
						/>
					</div>

					<DatePicker
						className='mb-3'
						label='Delivery Date'
                        labelColor = '#305399'
                        background='#FEF7F5'
						color='#314783'
						minimumDate = {new Date()}
						outerProperties='rounded py-0.5 border border-[#0000001a]'
						suffix={
							<StyledQuantitySuffix className='text-white bg-theme-blue p-2 m-1 text-sm flex justify-center items-center'>
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
									<path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
								</svg>
							</StyledQuantitySuffix>
						}
						name='expected_date'
						value={values.expected_date && format(values.expected_date, "dd/MM/yyyy")}
						onBlur={handleBlur}
						error={errors.expected_date}
						touched={touched.expected_date}
						initialValue = {values.expected_date}
						onChange = {(date : any) => setFieldValue('expected_date', date)}
					/>

					<Input
						className='mb-3'
						label='Required Manufacturer'
                        labelColor = '#305399'
                        background='#FEF7F5'
						color='#314783'
						outerProperties='rounded py-[11px] border border-[#0000001a]'
						onChange={handleChange}
						name='required_manufacturer'
						value={values.required_manufacturer}
						onBlur={handleBlur}
						error={errors.required_manufacturer}
						touched={touched.required_manufacturer}
					/>

					<div>
						<label className='inline-block mb-1 text-[#305399]'> Certificates </label>
						<Select
							search
							color='#314783'
							placeholder='eg. GMP, DMF'
                            background='#FEF7F5'
							additionalStyles={{
								border: '',
								padding: '2px 0'
							}}
							multi
							suffix={
								<StyledQuantitySuffix className='text-white bg-theme-blue p-2 m-1 text-sm flex justify-center items-center'>
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
										<path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
									</svg>
								</StyledQuantitySuffix>
							}
							items={certificateList.list}
							onChange={(selected : any) => setFieldValue('expected_certificates', selected)}
							error={errors.expected_certificates}
							placeholderStyles={{
								fontSize: 13,
								fontWeight: 300
							}}
							name = "expected_certificates"
							value = {values.expected_certificates}
							touched = {touched.expected_certificates}
						/>
					</div>

					<div>
						<label className='inline-block mb-1 text-[#305399]'> Pharmacopoeia Grades </label>
						<Select
							search
							color='#314783'
							placeholder='eg. USP, IP'
                            background='#FEF7F5'
							additionalStyles={{
								border: '',
								padding: '2px 0'
							}}
							multi
							suffix={
								<StyledQuantitySuffix className='text-white bg-theme-blue p-2 m-1 text-sm flex justify-center items-center'>
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
										<path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
									</svg>
								</StyledQuantitySuffix>
							}
							items={pharmacopoeiaGradesList.list}
							onChange={(selected : any) => setFieldValue('pharmacopoeia_grades', selected)}
							placeholderStyles={{
								fontSize: 13,
								fontWeight: 300
							}}
							name = 'pharmacopoeia_grades'
							value = {values.pharmacopoeia_grades}
							error={errors.pharmacopoeia_grades}
							touched = {touched.pharmacopoeia_grades}
						/>
					</div>

					<div>
						<label className='inline-block mb-1 text-[#305399]'> Attach a file </label>
						<FileInput 
							name='attachment' 
							uniqueID = "enquiry__attachment" 
							disabled = {files.length}
							error = {errors.attachment}
						>
							<div className='border border-[#0000001a] flex justify-between items-center bg-[#FEF7F5] py-[2px] rounded text-sm font-light pl-2 text-[gray]'>
								{	
									files.length === 0 ?
									<span>Browse</span> 
									:
									<span className='flex'>  
										{ files.length && helpers.reduceStringLength(files[0].name) }
										<svg onClick={() => dispatch(deleteFile(files[0].id))} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 ml-2">
											<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
										</svg>
									</span>
								}
								<StyledQuantitySuffix className='text-white bg-theme-blue p-2 m-1 text-sm flex justify-center items-center'>
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
									<path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
								</svg>

								</StyledQuantitySuffix>
							</div>
						</FileInput>
					</div>
					
					<div className='lg:col-span-2'>
						<Input
							className='mb-3'
							label='Shipping Terms'
							labelColor = '#305399'
							background='#FEF7F5'
							color='#314783'
							placeholder = "Enter Shipping terms"
							outerProperties='rounded py-[11px] border border-[#0000001a]'
							onChange={handleChange}
							name='shipping_terms'
							value={values.shipping_terms}
							onBlur={handleBlur}
							error={errors.shipping_terms}
							touched={touched.shipping_terms}
						/>
					</div>

					<div className='col-span-full'>
						<TextArea
							outerProperties='w-full mt-3 pt-3 rounded placeholder:text-sm placeholder:font-light border border-[#0000001a]'
							rows={4}
							background = '#FEF7F5'
							color = '#314783'
							placeholder="Any Additional Comments?"
							onChange={handleChange}
							name='message'
							value={values.message}
							onBlur={handleBlur}
						/>
					</div>

					<Button 
						styles='w-full text-white bg-theme-orange h-12 lg:w-[150px]'
						destinationEvent = ""
					> 
						Submit 
					</Button>
				</form>
			</div>

			<EnquiryForm
				show = {showEnquiryModal}
				data={values}
				payload={values}
				countryList={countryList.fixedList}
				onClose = {() => setShowEnquiryModal(false)}
			/>

			<EnquirySuccess
				show={enquiryState.showSuccessModal}
				user={enquiryState.responseData ? enquiryState.responseData.user : ''}
			/>
		</>
	)
}

Enquiry.defaultProps = {
	firstHeading : "Didn't find what",
	secondHeading : "you're looking for?",
	subText : 'Share your requirement with us and we will find the best deal for you'
}

export default Enquiry